var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValC = function SvgValC(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2282 6.60034C15.2282 6.60034 15.7698 7.142 16.3115 8.22534C16.3115 8.22534 18.0329 5.517 19.5615 4.97534M9.82776 1.18909C7.12051 1.07534 5.02968 1.38625 5.02968 1.38625C3.70909 1.48159 1.17951 2.22042 1.17951 6.54509C1.17951 10.8308 1.15134 16.1153 1.17951 18.2223C1.17951 19.5093 1.97576 22.5123 4.73393 22.6727C8.08684 22.8677 14.1264 22.9099 16.8976 22.6727C17.6386 22.6304 20.1086 22.0487 20.4206 19.362C20.7456 16.5778 20.6806 14.6441 20.6806 14.1837",
    stroke: "#E5B42F",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56152 13.1003H10.8949M6.56152 17.4336H15.2282M22.8332 6.60026C22.8332 9.59135 20.4065 12.0169 17.4111 12.0169C16.6993 12.0176 15.9944 11.8781 15.3366 11.6062C14.6788 11.3343 14.081 10.9354 13.5774 10.4323C13.0739 9.92929 12.6744 9.33192 12.4019 8.67438C12.1293 8.01685 11.989 7.31205 11.989 6.60026C11.989 3.6081 14.4168 1.1836 17.4111 1.1836C18.1229 1.18288 18.8278 1.32247 19.4856 1.59436C20.1434 1.86625 20.7412 2.26513 21.2448 2.76818C21.7483 3.27124 22.1478 3.86861 22.4204 4.52614C22.6929 5.18368 22.8332 5.88848 22.8332 6.60026Z",
    stroke: "#E5B42F",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValC);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ValC.c08e274da9fa01e2419b02ad2cab2bb6.svg";